import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CloseIcon from '@wix/da-ds/pkg/Icons/generated/components/CloseThin';
import s from './CloseButton.scss';
var CloseButton = /** @class */ (function (_super) {
    __extends(CloseButton, _super);
    function CloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseButton.prototype.render = function () {
        var size = this.props.size || (this.props.isMobile ? '1em' : '1.35em');
        return (React.createElement(PlainButtonOrLink, { className: classnames(s['root'], this.props.className), onClick: this.props.onClick },
            React.createElement(CloseIcon, { size: size })));
    };
    return CloseButton;
}(React.Component));
export default withTranslation()(withMobileContext(CloseButton));
//# sourceMappingURL=CloseButton.js.map